import React, { useContext } from 'react';

const Context = React.createContext({});

const Provider = props => (
  <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

const useVariablesContext = () => useContext(Context);

export { Context, Provider, useVariablesContext };
